import React from "react";
import { Link, Outlet, useNavigate, useLocation } from "react-router-dom";

export default function Error() {
  let navigate = useNavigate();

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        backgroundColor: "white",
        width: "100%",
        height: "70vh",
      }}
    >
      <p
        style={{
          textAlign: "center",
          marginTop: "25vh",
          fontSize: "1.5rem",
          fontWeight: "bold",
        }}
      >
        HTTP 404 Error <br />웹 페이지를 찾을 수 없습니다.
        <br />
        <div style={{ marginTop: "3vh" }} className="btn_color">
          <a href="/" style={{ color: "white" }}>
            홈으로 돌아가기
          </a>
        </div>
      </p>
    </div>
  );
}
